import { render, staticRenderFns } from "./autoRouterparent.vue?vue&type=template&id=bf30e490&scoped=true&"
import script from "./autoRouterparent.vue?vue&type=script&lang=js&"
export * from "./autoRouterparent.vue?vue&type=script&lang=js&"
import style0 from "./autoRouterparent.vue?vue&type=style&index=0&id=bf30e490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf30e490",
  null
  
)

export default component.exports